module.exports = __webpack_public_path__ + "static/img/celoscope-31.8e8b37a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-31.jpg
// module id = K1vZ
// module chunks = 52